module.exports = __webpack_public_path__ + "static/media/graph-text-home.27ae44d5.png";